import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { inventoryCheckService } from 'shared/services';
import toast from 'shared/utils/toast';
import InventoryCheckForm from '../components/InventoryCheckForm';
import { IInventoryCheck } from '../types';

export const EditInventory = () => {
  const translationPrefix = 'pages.inventory-check.edit';
  const { t } = useTranslation();

  const { inventoryId } = useParams();
  const [inventory, setInventory] = useState<IInventoryCheck>();

  useEffect(() => {
    inventoryCheckService.get(inventoryId).then(setInventory);
  }, []);

  const updateInventory = async (values) => {
    inventoryCheckService.update(inventory.id, values).then((res) => {
      toast.success('Inventario aggiornato con successo');
      inventoryCheckService.get(inventoryId).then(setInventory);
    });
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`, { code: inventory?.code || '' })}
      subtitle={t(`${translationPrefix}.subtitle`)}
      entityCode="">
      <InventoryCheckForm inventory={inventory} onSubmit={updateInventory} />
    </TenantPage>
  );
};

export default EditInventory;
